import { USER_ROLE_LABELS } from '@crm/shared';
export const AUTH_ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/esqueci-senha',
  RESET_PASSWORD: '/redefinir-senha',
  DASHBOARD: '/',
} as const;

/** Chaves do TanStack Query usadas pelo modulo. */
export const AUTH_QUERY_KEYS = {
  me: ['auth', 'me'] as const,
  permissions: ['auth', 'permissions'] as const,
  health: ['system', 'health'] as const,
  queues: ['system', 'queues'] as const,
};

export const AUTH_ENDPOINTS = {
  REGISTER: '/api/v1/auth/register',
  LOGIN: '/api/v1/auth/login',
  LOGOUT: '/api/v1/auth/logout',
  ME: '/api/v1/auth/me',
  CHANGE_PASSWORD: '/api/v1/auth/change-password',
  FORGOT_PASSWORD: '/api/v1/auth/forgot-password',
  RESET_PASSWORD: '/api/v1/auth/reset-password',
  PERMISSIONS: '/api/v1/permissions',
  GOOGLE_SIGN_IN: '/api/auth/sign-in/social',
  HEALTH: '/health',
  QUEUES: '/queues',
  ACCOUNTS: '/api/v1/auth/accounts',
  SWITCH: '/api/v1/auth/switch',
} as const;

export const ROLE_LABELS: Record<string, string> = USER_ROLE_LABELS;
